// outputNode.js
import { useState } from 'react';
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { useStore } from '../store';

export const OutputNode = ({ id, data }) => {
  const [currName, setCurrName] = useState(data?.outputName || id.replace('customOutput-', 'output_'));
  const [outputType, setOutputType] = useState(data?.outputType || 'Text');
  const updateNodeField = useStore((state) => state.updateNodeField);

  return (
    <BaseNode
      id={id}
      data={data}
      title="Output"
      handles={[
        { type: 'target', position: Position.Left, id: `${id}-value` }
      ]}
    >
      <Input
        label="Name"
        value={currName}
        onChange={(e) => {
          setCurrName(e.target.value);
          updateNodeField(id, 'outputName', e.target.value);
        }}
      />
      <Select
        label="Type"
        value={outputType}
        onChange={(e) => {
          setOutputType(e.target.value);
          updateNodeField(id, 'outputType', e.target.value);
        }}
        options={[
          { value: 'Text', label: 'Text' },
          { value: 'File', label: 'Image' }
        ]}
      />
    </BaseNode>
  );
}
